// 引入api请求方法
import { getVehicleList } from '@/api/capacity';
import { getCollectionList } from '@/api/captain';
import { pageList } from '@/api/affiliation';

const storeModuleName = 'handModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'autocomplete',
      param: 'vehicleNo',
      value: '',
      valueType: 'string',
      label: '车牌号',
      placeholder: '请输入车牌号',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getvehiclelist`,
    },
    {
      style: 'autocomplete',
      param: 'name',
      value: '',
      valueType: 'string',
      label: '经纪人姓名',
      placeholder: '请输入经纪人姓名',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getPayee`,
    },
  ],

  isExport: {
    isShow: false,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '车牌号',
        prop: 'vehicleNo',
        checked: 1,
        sortable: true,
      },
      {
        label: '经纪人姓名',
        prop: 'name',
        checked: 1,
        sortable: true,
      },
      {
        label: '经纪人身份证号',
        prop: 'idCard',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-idCard',
      },
      {
        label: '操作',
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
    });
    const { data } = await pageList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  getvehiclelist: async (context, payload) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getVehicleList({
        vehicleNo: payload,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.vehicleNo;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取收款人列表
  getPayee: async (context, payload) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getCollectionList({
        payeeName: payload,
        payeeType: 2,
      });
      if (code === 200) {
        data.records.forEach(item => {
          item.value = item.payeeName;
        });
        resolve(data.records);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'projectName':
        state.postParams.projectId = payload.id;
        break;
      case 'orderName':
        state.postParams.orderId = payload.orderId;
        break;
      case 'payeeName':
        state.postParams.payeeMobile = payload.reserveMobileNo;
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
